import React,{ useState } from "react";
import { useDispatch } from "react-redux";
import { exportTasks } from "actions";
import { Excel } from "CommonComponent";
import DownloadPDF from "../DownloadPDF";
import { isEmpty } from "lodash";

const Header = ({onFilter, extraFiltersState, setExtraFiltersState, handleExport}) => {
  const [showAddNewModal, setShowAddNewModal] = useState(false);

  const handleOpenModal = () => setShowAddNewModal(true);
  const handleCloseModal = () => setShowAddNewModal(false);

  return (
    <>
      <div className="z-1">
        <div className="d-flex justify-content-between align-items-center p-4">
          <h1 className="font-24 font-weight-s-bold m-0">ACD</h1>
          <div className="d-flex gap-3">
            {!isEmpty(extraFiltersState.values) && extraFiltersState.values.month !== ''?
            <DownloadPDF extraFiltersState={extraFiltersState} />
            :''}
            <Excel handleExport={handleExport} />
            
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
